import { restrictedAccess } from '@/router/middleware'

export default {
  path: '/attendance-sheets',
  component: () => import('@/views/admin/attendance-sheets/Page.vue'),
}